<template>
  <v-alert :value="msg" type="error">
    <ul v-if="Array.isArray(msg)">
      <li v-for="(message, index) in msg" :key="index">
        {{ message }}
      </li>
    </ul>
    <div v-else>
      {{ msg }}
    </div>
  </v-alert>
</template>
<script>
  export default {
    props: {
      msg: {
        type: [Object, String],
        default: '',
      },
    },
  };
</script>